import React, { useState } from "react";
import { Box, Divider, Heading, SimpleGrid } from "@chakra-ui/react";
import { VscBellDot } from "react-icons/vsc";
import { IoNewspaperOutline } from "react-icons/io5";
import { RiLogoutBoxRLine } from "react-icons/ri";

import { logout } from "utils/auth";
import { useUser } from "context/user";
import { AuthenticatedLayout } from "layouts";
import { InstallerButton, ProfileInformation } from "components";
import NavLink from "components/PrimaryNav/NavLink";
import ProfileCard from "./ProfileCard";
import { ProfileForm } from "./ProfileForm";

const Profile: React.FC = () => {
  const { user } = useUser()!;
  const [editing, setEditing] = useState(false);

  return (
    <AuthenticatedLayout>
      <SimpleGrid
        columns={1}
        gap={8}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Heading as="h1" size="lg">
          Profile
        </Heading>
        <Box maxW="630px" m="0 auto">
          <ProfileCard />
          {/* <SimpleGrid mt={8} columns={[1, 3]} gap={4}>
            <NavLink
              to="/eula"
              label="Consent Form"
              bg="gray.700"
              icon={IoNewspaperOutline}
            />
            <NavLink
              to="/profile"
              label="Notification Preferences"
              bg="gray.700"
              icon={VscBellDot}
            />
            <NavLink
              to="/login"
              onClick={logout}
              label="Logout"
              bg="gray.700"
              icon={RiLogoutBoxRLine}
            />
          </SimpleGrid> */}
        </Box>
        <Divider />
        <Box
          borderRadius="xl"
          width="100%"
          p={8}
          bg="gray.800"
          boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
        >
          {editing ? (
            <ProfileForm callback={() => setEditing(false)} />
          ) : (
            <ProfileInformation
              btnLabel="Edit Profile"
              callback={() => setEditing(true)}
              feilds={[
                {
                  label: "First Name",
                  value: user.first_name
                },
                {
                  label: "Last Name",
                  value: user.last_name
                },
                {
                  label: "Username",
                  value: user.username
                },
                {
                  label: "Email",
                  value: user.email
                }
              ]}
            />
          )}
        </Box>
        <Box width="fit-content" justifySelf="flex-end">
          <InstallerButton />
        </Box>
      </SimpleGrid>
    </AuthenticatedLayout>
  );
};

export default Profile;
